import React from 'react';
import styles from './CheckInQr.module.css'; 
import { useHistory } from 'react-router-dom';
import CheckInIcon from '../icons/CheckInIcon';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const CheckInQr = () => {
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();
    const queryParams = new URLSearchParams(location.search);
    const referenceCode = queryParams.get('referenceCode');
    const showName = queryParams.get('showName');
    const id = queryParams.get('id');
    const codeTicket = queryParams.get('codeTicket');
  return (
    <div className={styles.paymentExit}>
    <div className={styles.successIcon}>
      <div className={styles.circle}>
        <CheckInIcon size={'110px'} color={'#FFF'} />
      </div>
    </div>
    <div className='container mx-1'>
      <div className={`font-large bold  ${styles.validTitle}`}>Check-in</div>
      <div className='font-medium mt-3 lh-title'>e-ticket {t('checkShow.successful')}</div>
      <div className='mt-4'>
        <div>
          <div className='font-tiny'>Ticket</div>
          <div className={`d-flex justify-content-between align-items-center ${styles.containerBorder}`}>
            <div className='font-normal bold'>{showName}</div>
          </div>
        </div>
        {/* <div className={`pt-2 d-flex ${styles.containerBorder}`}>
          <div className='col pl-0'>
            <div className='font-tiny'>Gate/Section</div>
            <div className='font-normal bold'>Puerta 2</div>
          </div>
          <div className='col-auto text-center pl-0'>
            <div className='font-tiny'>Row</div>
            <div className='font-normal bold'>1</div>
          </div>
          <div className='col-auto text-center pl-4 pr-4'>
            <div className='font-tiny'>Seat</div>
            <div className='font-normal bold'>2</div>
          </div>
        </div> */}
      </div>
      <div className='mt-2 font-tiny'>ID TICKET</div>
      <div className=' font-tiny'>#{codeTicket}</div>
      <div className='d-flex justify-content-end pt-4 pb-5'>
        <div
          className={`font-normal bold ${styles.button} ${styles.buttonBorderValid}`}
          onClick={() =>

            history.push({
              pathname: `/scan-qr-checker/${id}`,

            })
          }
        >
      {t('checkShow.following')}
        </div>
      </div>
    </div>
  </div>
  );
};

export default CheckInQr;
